import { exportStyledPdfMulti } from "./exportStyledPdf";
import {
  buildBothCurrencySections,
  type CurrencyReportBundle,
} from "./investorReportSections";

export type { CurrencyReportBundle };

/**
 * Combined investor PDF: the three finance reports for BOTH currencies stitched
 * into ONE document — six pages (Cash Flow / P&L / Balance Sheet × ETB/USD),
 * each on its own page. Consumes the SAME (rehydrated) hook outputs the table
 * components use, so the figures match the on-page view.
 */
export function exportCombinedInvestorPdf(params: {
  etb: CurrencyReportBundle;
  usd: CurrencyReportBundle;
  fileName: string;
}): Promise<void> {
  return exportStyledPdfMulti(
    buildBothCurrencySections(params.etb, params.usd),
    params.fileName
  );
}
